import styles from './OptionsGrid.module.scss';
import { useNavigate } from 'react-router';
import { AnswerBlock } from '../../../../components/AnswerBlock/AnswerBlock';
import { AnswerItem } from '../../../../components/AnswerItem/AnswerItem';
import { Subtitle } from '../../../../components/Subtitle/Subtitle';
import { useUserData } from '../../../../providers/UserDataProvider/useUserData';
import { ContinueButton } from '../../../../components/ContinueButton/ContinueButton';
import { Image } from '../../../../components/Image/Image';
import { ampScreenCompleted } from '../../../../utils/AmplitudeEvents';
export const OptionsGrid = ({ content, nextSlug }) => {
  const { userData, setUserData } = useUserData();
  const navigate = useNavigate();
  const { title, subtitle, answers, slug, button,background } = content;
  const key = title || `question_${slug}`;

  // Получаем текущие выбранные ответы для этого вопроса
  const currentSelectedItems = userData?.answers?.[key] || [];

  const handleSelect = (box) => {
    // Проверяем, был ли выбран этот вариант
    const isSelected = currentSelectedItems.includes(box.answer);
    let updatedSelectedItems;
    let deltaE = 0;
    let deltaP = 0;
  
    if (isSelected) {
      // Убираем вариант и вычитаем баллы
      updatedSelectedItems = currentSelectedItems.filter(item => item !== box.answer);
      deltaE = -(box.points?.E ?? 0);
      deltaP = -(box.points?.P ?? 0);
    } else {
      // Добавляем вариант и прибавляем баллы
      updatedSelectedItems = [...currentSelectedItems, box.answer];
      deltaE = box.points?.E ?? 0;
      deltaP = box.points?.P ?? 0;
    }
  
    setUserData(prev => ({
      ...(prev || {}),
      answers: {
        ...(prev.answers || {}),
        [key]: updatedSelectedItems,
      },
      points: {
        E: (prev?.points?.E || 0) + deltaE,
        P: (prev?.points?.P || 0) + deltaP,
      },
    }));
  };
  
  



  return (
    <>
      <div className={styles.section}>
        <div className={styles.head}>
          {title && <div className={styles.titleBlock} dangerouslySetInnerHTML={{ __html:title }}/>}
          {subtitle && <Subtitle className={styles.subtitle}>{subtitle}</Subtitle>}
          {background && <Image src={background} className={styles.background} />}
        </div>
        {answers && (
          <AnswerBlock>
            {answers.map((box, index) => {
              const isActive = currentSelectedItems.includes(box.answer);
              return (
                <AnswerItem
                  key={index}
                  type={"checkbox"}
                  status={isActive ? 'active' : null}
                  onClick={() => handleSelect(box)}
                >
                  {box}
                </AnswerItem>
              );
            })}
          </AnswerBlock>
        )}
      </div>
      <ContinueButton
        status={currentSelectedItems.length === 0 && 'disabled'}
        onClick={() => {
          ampScreenCompleted(slug,title ||null, currentSelectedItems.join(', '))
          setTimeout(() => {
            navigate(nextSlug);
          }, 500);
        }}
      >
        {button || null}
      </ContinueButton>
    </>
  );
};
